module.exports = __webpack_public_path__ + "static/pic12-f59034d831150c87867483ad4830f534.jpg";